import { AxiosResponse } from 'axios';
import { ImResponse } from '..';
import { i18nExist } from 'services/i18n/utils';
import { tolgee } from 'services/i18n/tolgee';

const code2I18n: Record<number, string> = {
  5001: '订单完成后发起的退单，不支持发起争议',
  5002: '当前退单状态不可发起争议',
  5003: 'Shopee官方服务出现异常，如有疑问请联系乐聊技术支持人员',
  5004: '服务异常，请稍后重试',
  5005: '退款金额仅支持输入整数',
  5006: '退款金额仅支持输入小数点后两位',
  5007: '提交证据已逾期',
  5008: '买家尚未提交证据，若买家逾期未提交证据，申请将会被自动取消',
  5009: 'Tiktok官方服务出现异常，如有疑问请联系乐聊技术支持人员',
  5010: '保证正品的订单不支持操作，请等待卖家中心仲裁结果',
  5011: '当前申请已撤销',
  5012: '保证正品的订单不支持操作，请等待卖家中心仲裁结果',
  5013: '当前申请已转接至平台运营商',
  5014: 'Lazada官方服务出现异常，如有疑问请联系乐聊技术支持人员',
  5015: '当前申请不支持该操作',
  5016: 'MP3（Marketplace Ease Mode）模式的店铺不支持该操作',
  5017: '店铺授权状态异常，请检查店铺授权状态后重试',
  5018: '拒绝操作不支持多选订单操作',
  5019: 'Mercado官方服务出现异常，如有疑问请联系乐聊技术支持人员',
};

/**
 * 获取 Api 错误码提示
 */
export const getApiErrorCodeMsg = (
  response: AxiosResponse<ImResponse>,
  fallbackI18nKey?: string,
) => {
  const code = response?.data?.code;
  const codeI18nKey = code2I18n[code];
  const key = i18nExist(codeI18nKey)
    ? codeI18nKey
    : fallbackI18nKey || 'translation.操作失败，请稍后再试';
  return tolgee.t(key);
};
